import { CircularProgress, Grid, styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

import Modal from "../../../../../../../../components/Generic/Modal";

export const Dropzone = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  padding: "24px 1.5px 1.5px",
  width: "100%",
  cursor: "pointer",
}));

export const DropzoneButton = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",

  borderColor: colors.gray200,
  borderRadius: "8px",
  borderStyle: "dashed",
  borderWidth: "3px",

  width: "100%",
  padding: "25px 16px",
}));

export const DropzoneText = styled("p")(() => ({
  color: colors.brandBlue600,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  margin: "0",
}));

export const DropzoneInfoText = styled("p")(() => ({
  alignItems: "center",
  display: "flex",

  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  margin: "0px",
}));

export const DropzoneBoldInfoText = styled(DropzoneInfoText)(() => ({
  textAlign: "center",
  fontWeight: 600,
  letterSpacing: "0.1px",
}));

export const TextWrapper = styled("div")(({ gap }: { gap?: string }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: gap || "4px",
}));

export const UploadDocumentModal = styled(Modal)(() => ({
  width: "676px !important",

  "& > div > div:last-child": {
    background: colors.white,
  },
}));

export const ModalHeaderTitleWrapper = styled("span")(() => ({
  color: colors.gray700,
  fontfamily: "Manrope",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "140%",
}));

export const ModalHeaderWrapper = styled(Grid)(() => ({
  alignContent: "center",
  display: "flex",
  justifyContent: "center",
  padding: "0 1.5px 24px",
}));

export const CloseModalButtonWrapper = styled(Grid)(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end",
  "& > svg": {
    cursor: "pointer",
  },
}));

export const LoadingDiv = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0 3rem 0",
}));

export const LoadingContainer = styled("div")(() => ({
  display: "flex",
  width: "80%",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "40px",
  alignSelf: "center",
}));

export const LoadingTitle = styled("span")(() => ({
  color: colors.brandBlue600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  textAlign: "center",
}));

export const LoadingProgress = styled(CircularProgress)(() => ({
  width: "25% !important",
  height: "100% !important",
  color: colors.brandBlue500,
}));

export const ErrorTitle = styled(Grid)(() => ({
  color: colors.gray600,
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const ErrorLine = styled(Grid)(() => ({
  color: colors.error600,
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const CancelButtonWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "calc(100% + 3rem)",

  borderTop: `1px solid ${colors.gray200}`,
  position: "relative",
  right: "-1.5rem",
  padding: "16px 16px 0 0",
  marginLeft: "-28px",

  "& > button": {
    marginRight: "14px",

    "&:active": {
      color: colors.gray600,
    },
  },
}));

export const RejectedUploadTextWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "8px",
  marginTop: "16px",
}));
